import { useAgents } from "../agents/useAgents";

/** Agents from the sales department — the people the seller reports can be filtered by. */
export function useSellers() {
  const { agents } = useAgents();
  return agents.filter((agent) => agent.department === "SALES");
}

/** Comma-separated names of the given sellers, or "—" when none are selected. */
export function useSellerNames(sellerIds: string[]): string {
  const sellers = useSellers();
  const names = sellers.filter((seller) => sellerIds.includes(seller.id)).map((seller) => seller.name);
  return names.length > 0 ? names.join(", ") : "—";
}
